import { VisualElement } from 'api/clients/VisualElementClient'
import { ShimmeringColor } from 'components/BrandWizardVisualAnalysisModal/LoadingState'
import Styles from './ChooseTemplate.module.scss'
import { GeneratedDesignPreview } from './components/GeneratedDesignPreview'
import { times } from 'lodash'
import { NativeArchetypeItem } from 'components/Wizards/DesignWizard/TemplateAndCaption/TemplateField'
import { GeneratedArchetypePreview } from './components/GeneratedArchetypePreview/GeneratedArchetypePreview'

interface Props {
  onSelect: (item: VisualElement | NativeArchetypeItem, content: any) => void
  aspectRatio: number
  templates: Array<VisualElement | NativeArchetypeItem>
  twoByTwo?: boolean
  isLoading?: boolean
  templateBorderRadius?: number | string
}

export const TemplatesGrid = ({
  templates,
  isLoading,
  onSelect,
  aspectRatio,
  twoByTwo,
  templateBorderRadius,
}: Props) => {
  const style = { gridTemplateColumns: `repeat(${twoByTwo ? 2 : 1}, 1fr)` }

  return (
    <div className={Styles.templatesGrid} style={style}>
      {isLoading ? (
        <>
          {times(4, (i) => {
            return (
              <ShimmeringColor key={i} aspectRatio={aspectRatio} width="100%" borderRadius={templateBorderRadius} />
            )
          })}
        </>
      ) : (
        <>
          {templates.slice(0, 4).map((item, index) => {
            if ('isNativeLayout' in item && item.archetype) {
              return (
                <GeneratedArchetypePreview
                  key={`${item.id}-${index}`}
                  aspectRatio={aspectRatio}
                  archetype={item.archetype}
                  onPress={(content) => {
                    onSelect(item, content)
                  }}
                />
              )
            }
            return (
              <GeneratedDesignPreview
                key={`${item.id}-${index}`}
                templateId={item.id as number}
                onPress={(content) => {
                  onSelect(item, content)
                }}
                aspectRatio={aspectRatio}
                borderRadius={templateBorderRadius}
              />
            )
          })}
        </>
      )}
    </div>
  )
}
